import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IActionErrorInfo } from "../../jobs/types/IActionErrorInfo";
import { createTicketGridFromTemplate } from "../thunks/createTicketGridFromTemplate";
import { ITicketGridsState } from "../types/ITicketGridsState";

export const addCreateTicketGridFromTemplate = (
  builder: ActionReducerMapBuilder<ITicketGridsState>,
) => {
  builder.addCase(createTicketGridFromTemplate.pending, (state) => {
    state.ticketGridsCreating = true;
  });
  builder.addCase(createTicketGridFromTemplate.rejected, (state, action) => {
    state.ticketGridsCreating = false;
    const error: IActionErrorInfo = {
      id: Date.now(),
      message: `Ошибка запуска билетной сетки! "${action.meta.arg.name}": ${action.error.message}`,
    };
    state.errors = state.errors ? [...state.errors, error] : [error];
  });
  builder.addCase(createTicketGridFromTemplate.fulfilled, (state, action) => {
    if (action.payload.reportID) {
      state.updated = [
        ...state.updated,
        {
          id: action.payload.reportID,
          message: `Задача из шаблона "${action.meta.arg.name}" успешно создана`,
        },
      ];
    }
    state.ticketGridsCreating = false;
  });
};
